// extracted by mini-css-extract-plugin
export default {"recos":"f6-z","productCardOverride":"g6-z","rowHasBadge":"h6-z"};